import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import AuthSlice from "../modules/Auth/services/AuthSlice";
import AuthSystem from "../modules/Auth/services/AuthSystemSlice";
import OssAuthSlice from "../modules/AuthOss/services/OssAuth";
import PuAuthSlice from "../modules/AuthPu/services/PuAuth";
import Pu from "../modules/Pu/services/DataNIBChecklist";
import PuKbli from "../modules/Pu/services/DataNIBKbli";
import InquiryNIB from "../modules/Pu/services/DataNIB";
import SalihaAuthSlice from "modules/AuthSaliha/services/SalihaAuth";
import SalihaRegistrationSlice from "modules/AuthSaliha/services/SalihaSubmission";

import OAuth from "modules/OAuth/services/OAuth";
import RegistrationSelfdeclare from "modules/Registration/services/RegistrationSelfdeclare";
import RegistrationReguler from "modules/Registration/services/RegistrationReguler";

import LnswAuthSlice from "modules/AuthLnsw/services/LnswAuth";
import LnswRegistrationSlice from "modules/AuthLnsw/services/LnswSubmission";

export const store = configureStore({
  reducer: {
    auth: AuthSlice,
    authsystem: AuthSystem,
    ossAuthSlice: OssAuthSlice,
    salihaAuthSlice: SalihaAuthSlice,
    salihaSubmission: SalihaRegistrationSlice,
    puAuthSlice: PuAuthSlice,
    pu: Pu,
    puKbli: PuKbli,
    inquiryNIB: InquiryNIB,
    registrationSelfdeclare: RegistrationSelfdeclare,
    registrationReguler: RegistrationReguler,
    oauth: OAuth,
    lnswAuthSlice: LnswAuthSlice,
    lnswSubmission: LnswRegistrationSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
